export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14495.2ab52789.jpg";